export default __webpack_public_path__ + "static/media/ico_camera.0fdccf9e.png";